module.exports = __webpack_public_path__ + "img/sld_step_down_transformer_h_l1_dark.dd7ced8d.svg";